import React from "react";

export const ChatWindowSkeleton = () => {
  return (
    <div>
      <div className="chat-window-skeleton-reciever">
        <div
          className="skeleton"
          style={{ width: "48px", height: "48px", borderRadius: "50%" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "230px", height: "60px",borderRadius:"4px 16px 16px 16px"  }}
        ></div>
      </div>

      <div
        className="message-sender sender-msg-box chat-window-skeleton-sender"
        style={{ alignItems: "start" }}
      >
        <div
          className="skeleton"
          style={{ width: "24px", height: "24px", borderRadius: "50%" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "230px", height: "60px",borderRadius:"16px 16px 4px 16px" }}
        ></div>
      </div>
      <div className="chat-window-skeleton-reciever">
        <div
          className="skeleton"
          style={{ width: "48px", height: "48px", borderRadius: "50%" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "230px", height: "60px",borderRadius:"4px 16px 16px 16px" }}
        ></div>
      </div>

      <div
        className="message-sender sender-msg-box chat-window-skeleton-sender"
        style={{ alignItems: "start" }}
      >
        <div
          className="skeleton"
          style={{ width: "24px", height: "24px", borderRadius: "50%" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "230px", height: "60px",borderRadius:"16px 16px 4px 16px"  }}
        ></div>
      </div>
    </div>
  );
};
